/** Numeric parsing and comparison helpers shared by the exercise graders. */

/** Accepts `1,234`, `1 234`, `12.5`, `-3`, and `50%`. Returns `null` otherwise. */
export function parseNumber(input: string): number | null {
  let text = input.trim().replace(/[,\s]/g, '');
  if (text === '') return null;

  let percent = false;
  if (text.endsWith('%')) {
    percent = true;
    text = text.slice(0, -1);
  }
  if (!/^-?(\d+\.?\d*|\.\d+)$/.test(text)) return null;

  const value = Number(text);
  if (!Number.isFinite(value)) return null;
  return percent ? value / 100 : value;
}

/** Relative comparison, so tolerance means the same thing at 0.5 and at 5000. */
export function numbersMatch(a: number, b: number, tolerance = 1e-9): boolean {
  const scale = Math.max(1, Math.abs(a), Math.abs(b));
  return Math.abs(a - b) <= tolerance * scale;
}

export function roundTo(value: number, decimals: number): number {
  const scale = 10 ** decimals;
  return Math.round((value + Number.EPSILON) * scale) / scale;
}

/** `1234567 → "1,234,567"` — used in place-value lessons. */
export function withThousandsSeparators(value: number): string {
  return value.toLocaleString('en-US');
}

export function decimalPlaces(value: number): number {
  const text = String(value);
  return text.includes('.') ? (text.split('.')[1] as string).length : 0;
}

export function range(start: number, end: number, step = 1): number[] {
  const out: number[] = [];
  for (let value = start; step > 0 ? value <= end : value >= end; value += step) out.push(value);
  return out;
}

export function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}
